export default __webpack_public_path__ + "static/pic09-8abff0b51ad3183d030fa8c0b95859d2.jpg";